<template>
  <b-img
    width="50"
    height="50"
    :src="imgSrc"
    alt="logo"
    class="rounded-circle"
    style="object-fit: cover;"
  />
</template>

<script>

import { BImg } from 'bootstrap-vue'

export default {
  name: 'Logo',
  components: { BImg },
  props: {
    logoUrl: {
      type: String,
      default: null,
    }
  },
  computed: {
    imgSrc() {
      if (!this.logoUrl) {
        return require(`@/assets/images/logo/${process.env.VUE_APP_LOGO_BRAND}`)
      }
      return this.logoUrl
    },
  },
}
</script>
